/**
 * OIDC redirect endpoints. /auth/callback finishes the code exchange
 * (handled by react-oidc-context) then routes back to where the user started;
 * /auth/silent-renew is the hidden-iframe renewal target.
 */

import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router';

import { getUserManager } from '@/auth/oidc';

export function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const returnTo =
        (auth.user?.state as { returnTo?: string } | undefined)?.returnTo ?? '/';
      navigate(returnTo, { replace: true });
    }
  }, [auth.isAuthenticated, auth.user, navigate]);

  if (auth.error) {
    return (
      <div className="flex h-screen items-center justify-center px-4 text-center text-danger">
        Échec de connexion : {auth.error.message}
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center px-4 text-center text-muted">
      Finalisation de la connexion…
    </div>
  );
}

export function SilentRenew() {
  useEffect(() => {
    void getUserManager().signinSilentCallback();
  }, []);
  return null;
}
